import { createAction } from '@reduxjs/toolkit';
import type { Action } from 'redux';
import type { PopupOAuthProvider } from '../popupOAuthProviders.js';
import type { AuthProvider, User } from './types.js';

// First stage shared by all popup OAuth providers (osm, github, strava,
// microsoft): opens the provider's authorize popup.
export const authWithPopupOAuth = createAction<{
  provider: PopupOAuthProvider;
  connect: boolean;
  // Dispatched once the login/connect succeeds (e.g. to reopen a modal).
  successAction?: Action;
  // Overrides the provider's default scope.
  scope?: string;
}>('AUTH_WITH_POPUP_OAUTH');

// Second stage shared by all popup OAuth providers: the callback relayed a
// `code`, which is exchanged for a session by the API.
export const authWithOAuthCode = createAction<{
  provider: PopupOAuthProvider;
  connect: boolean;
  code: string;
  successAction?: Action;
}>('AUTH_WITH_OAUTH_CODE');

export const authWithFacebook = createAction<{
  connect: boolean;
}>('AUTH_WITH_FACEBOOK');

export const authWithGoogle = createAction<{
  connect: boolean;
}>('AUTH_WITH_GOOGLE');

export const authWithApple = createAction<{
  connect: boolean;
}>('AUTH_WITH_APPLE');

export const authWithGarmin = createAction<{
  connect: boolean;
  successAction?: Action;
}>('AUTH_WITH_GARMIN');

export const authWithGarmin2 = createAction<{
  // connect: boolean;
  token: string;
  verifier: string;
  // successAction?: Action;
}>('AUTH_WITH_GARMIN_2');

export const authDisconnect = createAction<{
  provider: AuthProvider;
}>('AUTH_DISCONNECT');

export const authLogout = createAction('AUTH_LOGOUT');

export const authStartLogout = createAction('AUTH_START_LOGOUT');

export const authSetUser = createAction<User | null>('AUTH_SET_USER');

export const authSetOsmGpxAuthorized = createAction<boolean>(
  'AUTH_SET_OSM_GPX_AUTHORIZED',
);

export const authInit = createAction('AUTH_INIT');

export const authDeleteAccount = createAction('AUTH_DELETE_ACCOUNT');
